module.exports = __webpack_public_path__ + "static/media/mail.22f237a1.svg";